import { buildStatuteFaqs } from '../../lib/statuteSeoCopy';
import { statuteCardFullTitle } from '../../lib/statuteLandingMeta';
import type { Statute } from '../../hooks/useStatutes';

type StatuteSeoFaqPanelProps = {
  statute: Statute;
};

export default function StatuteSeoFaqPanel({ statute }: StatuteSeoFaqPanelProps) {
  const title = statuteCardFullTitle(statute);
  const yearMatch = title.match(/\b(1[89]\d{2}|20\d{2})\b/);
  const year = yearMatch ? parseInt(yearMatch[1], 10) : null;
  const faqs = buildStatuteFaqs(title, year);

  if (!faqs.length) return null;

  return (
    <section
      aria-labelledby="statute-seo-faq-heading"
      className="mx-4 mb-8 max-w-3xl rounded-2xl border border-border-light bg-white p-6 shadow-sm"
    >
      <h2 id="statute-seo-faq-heading" className="text-lg font-bold text-text-main mb-4">
        Frequently asked questions
      </h2>
      <dl className="space-y-4">
        {faqs.map((faq) => (
          <div key={faq.question}>
            <dt className="font-semibold text-text-main">{faq.question}</dt>
            <dd className="mt-1 text-sm leading-relaxed text-[#64748B]">{faq.answer}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
